export const getLoadErrorMessage = (code) => {
  switch(code) {
  case 4450:
    return 'Failed to run backtest because of an Error'
  case 4451:
    return 'Failed to run backtest: Another backtest for this algo is already running'
  case 4452:
    return 'Failed to run backtest: Your IB account is disabled'
  case 4453:
    return 'Failed to run backtest: Your IB account\'s credential is invalid'
  case 4454:
    return 'Failed to run backtest: IB account is required'
  case 4455:
    return 'Hourly data is available through Interactive broker. To activate your market data, go to your "User Settings" on your IB account and select "Market Data Subscriptions"'
  default:
    return 'Failed to run backtest: Unknown Error'
  }
}
